import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const generateWorkoutRoutines = async (llmPrompt, options = {}) => {
	const url = `${API_URL}/generate/generate-workout`;

	try {
		const body = { prompt: llmPrompt };
		if (options.maxTokens) {
			body.maxTokens = options.maxTokens;
		}

		const response = await axios.post(url, body);
		return response.data;
	} catch (error) {
		console.error('Error generating workout routine:', error);
		throw error;
	}
};
